import Page00 from '../../../../Book/EbookIntro/Pages/00';
import Page01 from '../../../../Book/EbookIntro/Pages/01';
import Page012 from '../../../../Book/EbookIntro/Pages/012';
import Page02 from '../../../../Book/EbookIntro/Pages/02';
import Page03 from '../../../../Book/EbookIntro/Pages/03';
import Page04 from '../../../../Book/EbookIntro/Pages/04';
import Page05 from '../../../../Book/EbookIntro/Pages/05';
import Page06 from '../../../../Book/EbookIntro/Pages/06';
import Page07 from '../../../../Book/EbookIntro/Pages/07';
import Page08 from '../../../../Book/EbookIntro/Pages/08';
import Page09 from '../../../../Book/EbookIntro/Pages/09';
import Page10 from '../../../../Book/EbookIntro/Pages/10';
import Page11 from '../../../../Book/EbookIntro/Pages/11';
import Page12 from '../../../../Book/EbookIntro/Pages/12';
import Page13 from '../../../../Book/EbookIntro/Pages/13';
import Page14 from '../../../../Book/EbookIntro/Pages/14';
import Page15 from '../../../../Book/EbookIntro/Pages/15';
import Page16 from '../../../../Book/EbookIntro/Pages/16';
import Page17 from '../../../../Book/EbookIntro/Pages/17';
import Page18 from '../../../../Book/EbookIntro/Pages/18';
import Page19 from '../../../../Book/EbookIntro/Pages/19';
import Page20 from '../../../../Book/EbookIntro/Pages/20';
import Page21 from '../../../../Book/EbookIntro/Pages/21';
import Page22 from '../../../../Book/EbookIntro/Pages/22';
import Page23 from '../../../../Book/EbookIntro/Pages/23';
import Page24 from '../../../../Book/EbookIntro/Pages/24';
import Page25 from '../../../../Book/EbookIntro/Pages/25';
import Page26 from '../../../../Book/EbookIntro/Pages/26';
import Page27 from '../../../../Book/EbookIntro/Pages/27';
import Page28 from '../../../../Book/EbookIntro/Pages/28';
import Page29 from '../../../../Book/EbookIntro/Pages/29';
import Page30 from '../../../../Book/EbookIntro/Pages/30';
import Page31 from '../../../../Book/EbookIntro/Pages/31';

type IntroContentProps = {
  readOnly: boolean;
};

const IntroContent = ({ readOnly }: IntroContentProps) => (
  <>
    <Page00 />
    <Page01 />
    <Page012 />
    <Page02 />
    <Page03 />
    <Page04 />
    <Page05 />
    <Page06 />
    <Page07 />
    <Page08 />
    <Page09 />
    <Page10 />
    <Page11 />
    <Page12 readOnly={readOnly} />
    <Page13 />
    <Page14 />
    <Page15 />
    <Page16 />
    <Page17 />
    <Page18 />
    <Page19 />
    <Page20 />
    <Page21 />
    <Page22 />
    <Page23 />
    <Page24 />
    <Page25 />
    <Page26 />
    <Page27 />
    <Page28 />
    <Page29 />
    <Page30 />
    <Page31 />
  </>
);

export default IntroContent;
